import {
  Card,
  CardHeader,
  CardContent,
  Paper,
  Typography,
  IconButton,
  Button,
  Box,
} from '@mui/material';
import QRCode from 'qrcode.react';
import GetAppIcon from '@mui/icons-material/GetApp';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import EditIcon from '@mui/icons-material/Edit';
import { makeStyles } from '@mui/styles';

const useStyles = makeStyles((theme) => ({
  card: {
    marginBottom: theme.spacing(3),
  },
  qrCodeContainer: {
    textAlign: 'center',
    padding: theme.spacing(3),
    marginTop: theme.spacing(2),
  },
  urlContainer: {
    display: 'flex',
    alignItems: 'center',
    marginTop: theme.spacing(2),
    padding: theme.spacing(1),
    backgroundColor: theme.palette.grey[100],
    borderRadius: theme.shape.borderRadius,
    wordBreak: 'break-all',
  },
  urlText: {
    flex: 1,
    marginRight: theme.spacing(1),
  },
  qrActionButtons: {
    display: 'flex',
    gap: theme.spacing(2),
    marginTop: theme.spacing(2),
    justifyContent: 'center',
  },
}));

const QrCodePreview = ({
  generatedQrCode,
  restaurant,
  onDownload,
  onCopyToClipboard,
  onEdit,
}) => {
  const classes = useStyles();

  return (
    <Card className={classes.card}>
      <CardHeader title="QR Code" />
      <CardContent>
        {generatedQrCode && generatedQrCode.shortUrl ? (
          <Paper className={classes.qrCodeContainer} elevation={0}>
            <QRCode
              id="generated-qr-code"
              value={generatedQrCode.shortUrl}
              size={280}
              bgColor="#ffffff"
              fgColor="#000000"
              level="H"
              includeMargin={true}
              imageSettings={{
                src: '/static/images/orderbuddy.jpeg',
                x: null,
                y: null,
                height: 28,
                width: 28,
                excavate: true,
              }}
            />

            {generatedQrCode.expiresAt && (
              <Typography variant="body2" color="textSecondary" style={{ marginTop: 16 }}>
                Expires: {new Date(parseInt(generatedQrCode.expiresAt)).toLocaleString()}
              </Typography>
            )}

            <div className={classes.urlContainer}>
              <Typography variant="body2" className={classes.urlText}>
                {generatedQrCode.shortUrl}
              </Typography>
              <IconButton size="small" onClick={onCopyToClipboard}>
                <ContentCopyIcon fontSize="small" />
              </IconButton>
            </div>
            
            <Typography variant="caption" color="primary" style={{ marginTop: 8, display: 'block' }}>
              ✓ Using shortened URL for cleaner QR code
            </Typography>

            <Box className={classes.qrActionButtons}>
              <Button
                startIcon={<GetAppIcon />}
                variant="outlined"
                onClick={onDownload}
              >
                Download
              </Button>
              <Button
                startIcon={<EditIcon />}
                variant="contained"
                color="secondary"
                onClick={onEdit}
              >
                Edit QR Code
              </Button>
            </Box>
          </Paper>
        ) : (
          <Paper className={classes.qrCodeContainer} elevation={0}>
            <Typography variant="body1" color="textSecondary" align="center">
              Click "Get QR Code" to generate a QR code
            </Typography>
            <Typography variant="body2" color="textSecondary" align="center" style={{ marginTop: 16 }}>
              The QR code will appear here once generated
            </Typography>
          </Paper>
        )}
      </CardContent>
    </Card>
  );
};

export default QrCodePreview;
